import {
  BaseResponse,
  MessageResponse,
  BasePaginationResponseV2,
  ResetMemberPasswordResponse,
  PageParams,
} from 'common/types/api'
import axios from 'core/api'
import { LoginBody } from 'modules/auth/api/types'
import { UserInfoResponse, UserRole } from 'modules/user/api/types'

import { buildUrlWithParams } from 'utils/url'

import {
  CreateEmployeeRequest,
  CreateMembersVariables,
  CreateRolesVariables,
  DeleteMembersVariables,
  EmployeeInfo,
  EmployeesParams,
  FarmManagerVariables,
  FeatureResponse,
  FollowOwnerBody,
  MemberResponse,
  MemberScopeFarm,
  RoleResponse,
  UpdateEmployeeVariables,
  UpdateMembersVariables,
  UpdateRolesVariables,
} from './types'

// Deprecated
export const getManagers = () => axios.get<BaseResponse<UserInfoResponse[]>>('/employees/managers')
// Deprecated
export const addFarmManager = ({ farmId, managerId }: FarmManagerVariables) =>
  axios.post<MessageResponse>(`/farms/${farmId}/managers/${managerId}`)
// Deprecated
export const removeFarmManager = ({ farmId, managerId }: FarmManagerVariables) =>
  axios.delete<MessageResponse>(`/farms/${farmId}/managers/${managerId}`)
// Deprecated
export const getRequestedEmployees = () =>
  axios.get<BaseResponse<UserInfoResponse[]>>('/employees/requested')
// Deprecated
export const acceptEmployee = (employeeId: string) =>
  axios.patch<MessageResponse>(`/employees/${employeeId}/approve`)
// Deprecated
export const rejectEmployee = (employeeId: string) =>
  axios.patch<MessageResponse>(`/employees/${employeeId}/reject`)
// Deprecated
export const removeEmployee = (employeeId: string) =>
  axios.delete<MessageResponse>(`/employees/${employeeId}`)
// Deprecated
export const followOwner = (body: FollowOwnerBody) =>
  axios.post<MessageResponse>(`/employees/request_follow`, body)
// Deprecated
export const updateEmployeeRole = ({ employeeId, role }: UpdateEmployeeVariables) =>
  axios.patch<MessageResponse>(`/employees/${employeeId}/role`, { role })
// Deprecated
export const getPondCaretakers = () =>
  axios.get<BaseResponse<UserInfoResponse[]>>('/employees/pond_caretakers')

// v2
// Deprecated
export const getEmployees = (params: EmployeesParams) =>
  axios.get<BasePaginationResponseV2<EmployeeInfo[]>>(buildUrlWithParams('/v2/employees', params))

export const createEmployee = (body: CreateEmployeeRequest) =>
  axios.post<MessageResponse>('/v2/employee', body)

// v3
export const getMembers = ({ userId }: { userId: string }) =>
  axios.get<BaseResponse<MemberResponse[]>>(`/user/${userId}/members`)

export const updateMembers = ({ userId, memberId, body }: UpdateMembersVariables) =>
  axios.patch<MessageResponse>(`/user/${userId}/members/${memberId}`, body)

export const deleteMembers = ({ userId, memberId }: DeleteMembersVariables) =>
  axios.delete<MessageResponse>(`/user/${userId}/members/${memberId}`)

export const createMembers = ({ userId, body }: CreateMembersVariables) =>
  axios.post<BaseResponse<LoginBody>>(`/user/${userId}/members`, body)

export const getRoles = ({ userId }: { userId: string }) =>
  axios.get<BaseResponse<RoleResponse[]>>(`/user/${userId}/roles`)

export const getRolesPreset = ({ userId }: { userId: string }) =>
  axios.get<BaseResponse<RoleResponse[]>>(`/user/${userId}/roles/preset`)

export const createRoles = ({ userId, body }: CreateRolesVariables) =>
  axios.post<BaseResponse<MessageResponse>>(`/user/${userId}/roles`, body)

export const getRole = ({ userId, roleId }: { userId: string; roleId: string }) =>
  axios.get<BaseResponse<UserRole>>(`/user/${userId}/roles/${roleId}`)

export const removeRole = ({ userId, roleId }: { userId: string; roleId: string }) =>
  axios.delete<BaseResponse<MessageResponse>>(`/user/${userId}/roles/${roleId}`)

export const updateRole = ({ userId, roleId, body }: UpdateRolesVariables) =>
  axios.patch<BaseResponse<MessageResponse>>(`/user/${userId}/roles/${roleId}`, body)

export const getFeatures = ({ userId }: { userId: string }) =>
  axios.get<BaseResponse<FeatureResponse[]>>(`/user/${userId}/members/features`)

export const resetPassword = ({ userId, memberId }: { userId: string; memberId: string }) =>
  axios.patch<BaseResponse<ResetMemberPasswordResponse>>(
    `/user/${userId}/members/${memberId}/reset-password`
  )

  // TODO: check this
export const getFarmsGroup = ({ name, params }: { name: string; params: PageParams }) =>
  axios.get<BasePaginationResponseV2<MemberScopeFarm>>(`/farms/group`, {
    params,
  })
